import {TheBorderNormalBetPresentation} from "../TheBorderNormalBetPresentation";

/**
 * Created by Jerker Nord on 2022-06-30.
 */

export class TheBorderSuperFSBetPresentation extends TheBorderNormalBetPresentation {
    protected setWinMultiplier(): void {
        // keep it as a stub, as we don't need it SUPER FS.
    }
}